import { createAction } from '@reduxjs/toolkit'

import { FortnoxTenantStatus, Integration } from 'types/GlobalIntegration'

// tryGetIntegrations
export const getIntegrations = createAction('get_integrations')
export const getIntegrationsSuccess = createAction<Integration[]>(
  'get_integrations_success'
)
export const getIntegrationsFailed = createAction('get_integrations_failed')

// tryGetFortnoxTenantStatus
export const getFortnoxTenantStatus = createAction('get_fortnox_tenant_status')
export const getFortnoxTenantStatusSuccess = createAction<
  FortnoxTenantStatus[]
>('get_fortnox_tenant_status_success')
export const getFortnoxTenantStatusFailed = createAction(
  'get_fortnox_tenant_status_failed'
)

// tryRemoveFortnoxTenant (payload is the removed tenant key)
export const removeFortnoxTenant = createAction('remove_fortnox_tenant')
export const removeFortnoxTenantSuccess = createAction<{
  activeSourceId: string
  tenantId: string
}>('remove_fortnox_tenant_success')
export const removeFortnoxTenantFailed = createAction(
  'remove_fortnox_tenant_failed'
)
